import React from 'react';
import classNames from 'classnames';
import {SectionTilesProps} from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class Service extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'team section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'team-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: 'Unser Service',
      //paragraph: 'Lorem ipsum dolor sidquis nostrud exercitation.'
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content reveal-from-bottom" />
            <div className={tilesClasses}>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require('./../../assets/images/layout/icon-beratung.svg')}
                        alt="Beratung-Cesur"
                        width={100}
                        height={100} />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">
                      Persönliche Beratung
                    </h5>
                    <p className="m-0 text-sm">
                    Lassen Sie sich von uns beraten und wir bringen mit der richtigen Behandlung sowie Pflege Ihre Haut zum strahlen.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="150">
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require('./../../assets/images/layout/icon-face.svg')}
                        alt="Face-Cesur"
                        width={100}
                        height={100} />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">
                      Behandlungen
                    </h5>
                    <p className="m-0 text-sm">
                      Ob Oily, Dry, Combination oder Normal Skin. Wir haben nicht nur für jeden Hauttyp die richtige Behandlung sondern auch für jedes Hautproblem.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="300">
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require('./../../assets/images/layout/icon-gutschein.svg')}
                        alt="Gutschein-Cesur"
                        width={100}
                        height={100} />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">
                      Geschenkgutschein
                    </h5>
                    <p className="m-0 text-sm">
                      Verschenken Sie einen strahlend schönen Glow für die Haut - oder lassen Sie sich mit einer sanften Haarentfernung beschenken.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <br></br>
        <br></br>
      </section>
    );
  }
}

Service.propTypes = propTypes;
Service.defaultProps = defaultProps;

export default Service;